export default __webpack_public_path__ + "static/media/About-Us.be6d9946.jpg";